// Query param that tells the page to open the cart drawer on load (e.g. after sign-in).
// eslint-disable-next-line import/prefer-default-export
export const OPEN_CART_PARAM = 'open_cart';
